/* =======================================================================
   BioHippo — Resources & Insights listing behaviour
   Vanilla JS, no dependencies. Progressive enhancement over server-rendered
   article cards. See resources-insights.liquid for the tag contract.
   ========================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var SVG = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'
  };

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function parseList(v) { return (v || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean); }

  each(document.querySelectorAll('[data-ri]'), function (root) {
    var grid      = root.querySelector('[data-ri-grid]');
    if (!grid) return;
    var cards     = Array.prototype.slice.call(grid.querySelectorAll('[data-article]'));
    var facetsBox = root.querySelector('[data-ri-facets]');
    var appliedEl = root.querySelector('[data-ri-applied]');
    var countEl   = root.querySelector('[data-ri-count]');
    var emptyEl   = root.querySelector('[data-ri-empty]');
    var moreBtn   = root.querySelector('[data-ri-more]');
    var searchIn  = root.querySelector('[data-ri-search]');
    var sortSel   = root.querySelector('[data-ri-sort]');
    var perPage   = parseInt(root.getAttribute('data-per-page'), 10) || 9;

    // ---- model ----
    var data = cards.map(function (el) {
      return {
        el: el,
        featured: el.getAttribute('data-featured') === 'true',
        title: el.getAttribute('data-title') || '',
        date: parseInt(el.getAttribute('data-date'), 10) || 0,
        read: parseInt(el.getAttribute('data-read'), 10) || 0,
        type: (el.getAttribute('data-type') || 'Article').trim(),
        category: parseList(el.getAttribute('data-cat')),
        area: parseList(el.getAttribute('data-area')),
        technique: parseList(el.getAttribute('data-tech')),
        species: parseList(el.getAttribute('data-species'))
      };
    });

    var FACETS = [
      { key: 'category',  title: 'Product Category', ph: 'Search categories…' },
      { key: 'area',      title: 'Research Area',     ph: 'Search research areas…' },
      { key: 'technique', title: 'Technique',         ph: 'Search techniques…' },
      { key: 'species',   title: 'Species',           ph: 'Search species…' }
    ];

    var state = { search: '', type: 'All', sort: 'recent', view: 'grid', sel: {}, q: {} };
    FACETS.forEach(function (f) { state.sel[f.key] = {}; state.q[f.key] = ''; });

    // ---- facet value tables (counts over full data) ----
    function typeCounts() {
      var m = { All: data.length };
      data.forEach(function (d) { m[d.type] = (m[d.type] || 0) + 1; });
      return m;
    }
    function facetValues(key) {
      var m = {};
      data.forEach(function (d) { d[key].forEach(function (v) { m[v] = (m[v] || 0) + 1; }); });
      return Object.keys(m).sort(function (a, b) { return m[b] - m[a] || a.localeCompare(b); })
        .map(function (v) { return { value: v, count: m[v] }; });
    }

    // ---- auto-fill hero "Popular" chips from the top product categories ----
    var popularWrap = root.querySelector('[data-ri-popular]');
    if (popularWrap && popularWrap.getAttribute('data-ri-popular-auto') === 'true') {
      var popN = parseInt(popularWrap.getAttribute('data-ri-popular-count'), 10) || 6;
      var topCats = facetValues('category').slice(0, popN);
      if (topCats.length) {
        each(popularWrap.querySelectorAll('[data-ri-quick]'), function (c) { c.parentNode.removeChild(c); });
        topCats.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ri__chip';
          b.setAttribute('data-ri-quick', o.value);
          b.textContent = o.value;
          popularWrap.appendChild(b);
        });
      }
    }

    // ---- render sidebar ----
    function renderSidebar() {
      facetsBox.innerHTML = '';

      // content type (single select)
      var tc = typeCounts();
      var order = ['All'].concat(Object.keys(tc).filter(function (k) { return k !== 'All'; }));
      var typeWrap = document.createElement('div');
      typeWrap.className = 'ri-facet';
      typeWrap.innerHTML = '<div class="ri-facet__label">Content type</div>';
      var typeList = document.createElement('div');
      typeList.className = 'ri-type';
      order.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        if (state.type === t) b.className = 'is-active';
        b.innerHTML = '<span>' + t + '</span><span class="ri-facet__n">' + tc[t] + '</span>';
        b.addEventListener('click', function () { state.type = t; apply(); renderSidebar(); });
        typeList.appendChild(b);
      });
      typeWrap.appendChild(typeList);
      facetsBox.appendChild(typeWrap);

      // multi-select facets with search + scroll cap
      FACETS.forEach(function (f) {
        var all = facetValues(f.key);
        if (!all.length) return;
        var q = state.q[f.key].toLowerCase();
        var opts = all.filter(function (o) { return !q || o.value.toLowerCase().indexOf(q) > -1; });

        var wrap = document.createElement('div');
        wrap.className = 'ri-facet';
        wrap.innerHTML =
          '<div class="ri-facet__label">' + f.title + '</div>' +
          '<div class="ri-facet__search">' + SVG.search +
            '<input type="search" placeholder="' + f.ph + '" aria-label="' + f.title + '">' +
          '</div>';
        var qi = wrap.querySelector('input');
        qi.value = state.q[f.key];
        qi.addEventListener('input', function () {
          state.q[f.key] = qi.value;
          var l = wrap.querySelector('.ri-facet__list');
          l.parentNode.replaceChild(buildList(f, all), l);
          qi.focus();
        });
        wrap.appendChild(buildList(f, all));
        facetsBox.appendChild(wrap);
      });
    }

    function buildList(f, all) {
      var q = state.q[f.key].toLowerCase();
      var opts = all.filter(function (o) { return !q || o.value.toLowerCase().indexOf(q) > -1; });
      var list = document.createElement('div');
      list.className = 'ri-facet__list';
      if (!opts.length) { list.innerHTML = '<span class="ri-facet__none">No matching values</span>'; return list; }
      opts.forEach(function (o) {
        var row = document.createElement('label');
        row.className = 'ri-facet__row';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = !!state.sel[f.key][o.value];
        cb.addEventListener('change', function () {
          state.sel[f.key][o.value] = cb.checked;
          apply();
        });
        var name = document.createElement('span'); name.textContent = o.value;
        var n = document.createElement('span'); n.className = 'ri-facet__n'; n.textContent = o.count;
        row.appendChild(cb); row.appendChild(name); row.appendChild(n);
        list.appendChild(row);
      });
      return list;
    }

    // ---- editor's picks ----
    var picksSec = root.querySelector('[data-ri-picks]');
    if (picksSec) {
      var picks = data.filter(function (d) { return d.featured; }).slice(0, 3);
      if (picks.length) {
        var pg = root.querySelector('[data-ri-picks-grid]');
        picks.forEach(function (d) { pg.appendChild(d.el.cloneNode(true)); });
        picksSec.hidden = false;
      }
    }

    // ---- filtering ----
    function matches(d) {
      if (state.type !== 'All' && d.type !== state.type) return false;
      var q = state.search.trim().toLowerCase();
      if (q) {
        var hay = (d.title + ' ' + d.type + ' ' + d.category.join(' ') + ' ' + d.area.join(' ') + ' ' + d.technique.join(' ')).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      for (var i = 0; i < FACETS.length; i++) {
        var key = FACETS[i].key;
        var sel = Object.keys(state.sel[key]).filter(function (k) { return state.sel[key][k]; });
        if (sel.length) {
          var hit = d[key].some(function (v) { return sel.indexOf(v) > -1; });
          if (!hit) return false;
        }
      }
      return true;
    }

    function sortFn(a, b) {
      if (state.sort === 'recent') return b.date - a.date;
      if (state.sort === 'oldest') return a.date - b.date;
      if (state.sort === 'az') return a.title.localeCompare(b.title);
      if (state.sort === 'read') return a.read - b.read;
      return 0;
    }

    var shown = perPage;

    function apply(resetPage) {
      if (resetPage !== false) shown = perPage;
      var visible = data.filter(matches).sort(sortFn);

      // reorder + paginate in the DOM
      visible.forEach(function (d, i) {
        grid.appendChild(d.el);
        d.el.classList.toggle('is-hidden', i >= shown);
      });
      data.filter(function (d) { return visible.indexOf(d) === -1; })
        .forEach(function (d) { d.el.classList.add('is-hidden'); });

      countEl.textContent = '· ' + visible.length + (visible.length === 1 ? ' result' : ' results');
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      if (moreBtn) moreBtn.hidden = visible.length <= shown;

      renderApplied();
    }

    // ---- applied filter pills ----
    function renderApplied() {
      if (!appliedEl) return;
      var pills = [];
      if (state.type !== 'All') pills.push({ label: state.type, clear: function () { state.type = 'All'; renderSidebar(); } });
      FACETS.forEach(function (f) {
        Object.keys(state.sel[f.key]).filter(function (k) { return state.sel[f.key][k]; })
          .forEach(function (v) { pills.push({ label: v, clear: function () { state.sel[f.key][v] = false; renderSidebar(); } }); });
      });
      if (state.search.trim()) pills.push({ label: '“' + state.search.trim() + '”', clear: function () { state.search = ''; if (searchIn) searchIn.value = ''; } });

      appliedEl.hidden = pills.length === 0;
      appliedEl.innerHTML = pills.length ? '<span>Active</span>' : '';
      pills.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ri-pill';
        b.innerHTML = p.label + SVG.x;
        b.addEventListener('click', function () { p.clear(); apply(); });
        appliedEl.appendChild(b);
      });
      if (pills.length) {
        var clr = document.createElement('button');
        clr.type = 'button'; clr.className = 'ri__clear'; clr.textContent = 'Clear all';
        clr.style.padding = '0 4px';
        clr.addEventListener('click', clearAll);
        appliedEl.appendChild(clr);
      }
    }

    function clearAll() {
      state.type = 'All'; state.search = ''; if (searchIn) searchIn.value = '';
      FACETS.forEach(function (f) { state.sel[f.key] = {}; state.q[f.key] = ''; });
      renderSidebar(); apply();
    }

    // ---- wire controls ----
    if (searchIn) searchIn.addEventListener('input', function () { state.search = searchIn.value; apply(); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(false); });
    each(root.querySelectorAll('[data-ri-quick]'), function (chip) {
      chip.addEventListener('click', function () {
        state.search = chip.getAttribute('data-ri-quick');
        if (searchIn) searchIn.value = state.search;
        apply();
      });
    });
    each(root.querySelectorAll('[data-ri-view]'), function (btn) {
      btn.addEventListener('click', function () {
        state.view = btn.getAttribute('data-ri-view');
        grid.setAttribute('data-view', state.view);
        each(root.querySelectorAll('[data-ri-view]'), function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
    var clearTop = root.querySelector('[data-ri-clear]');
    if (clearTop) clearTop.addEventListener('click', clearAll);
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += perPage; apply(false); });

    // ---- deep-link filters from URL ----
    // Supports ?type=<exact label> and the legacy menu form ?tab=<slug>, plus
    // ?category= / ?area= / ?technique= / ?species= (repeatable) and ?q=<search>.
    var TAB_MAP = {
      'protocols': 'Protocol',
      'protocol': 'Protocol',
      'application-notes': 'Application Note',
      'application-note': 'Application Note',
      'case-studies': 'Case Study',
      'case-study': 'Case Study',
      'news-updates': 'News & Updates',
      'news': 'News & Updates',
      'blog': 'News & Updates',
      'comparison-tables': 'Comparison & Guide',
      'comparison-guides': 'Comparison & Guide',
      'comparison': 'Comparison & Guide'
    };
    function selectType(wanted) {
      if (!wanted) return;
      Object.keys(typeCounts()).forEach(function (t) {
        if (t.toLowerCase() === wanted.toLowerCase()) state.type = t;
      });
    }
    try {
      var params = new URLSearchParams(window.location.search);
      selectType(params.get('type'));
      var pTab = params.get('tab');
      if (pTab) selectType(TAB_MAP[pTab.trim().toLowerCase()] || pTab);
      ['category', 'area', 'technique', 'species'].forEach(function (key) {
        params.getAll(key).forEach(function (val) { if (val) state.sel[key][val] = true; });
      });
      var pq = params.get('q');
      if (pq) { state.search = pq; if (searchIn) searchIn.value = pq; }
    } catch (e) {}

    // ---- init ----
    renderSidebar();
    apply();
  });
})();
